


export class ViewPOObraMigoAprovado {
  "numeroDaPO";
  "lote";
  "PO";
  "POItem";
  "VendorName";
  "NCM";
  "MaterialDescription";
  "QtyOrdered";
  "UnitPrice";
  "linkDaObra";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewPOObraMigoAprovado`.
   */
  static getModelName() {
    return "ViewPOObraMigoAprovado";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewPOObraMigoAprovado for dynamic purposes.
  **/
  static factory(data) {
    return new ViewPOObraMigoAprovado(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ViewPOObraMigoAprovado',
      plural: 'ViewPOObraMigoAprovados',
      path: 'ViewPOObraMigoAprovados',
      properties: {
        "numeroDaPO": {
          name: 'numeroDaPO',
          type: 'string'
        },
        "lote": {
          name: 'lote',
          type: 'number'
        },
        "PO": {
          name: 'PO',
          type: 'string'
        },
        "POItem": {
          name: 'POItem',
          type: 'string'
        },
        "VendorName": {
          name: 'VendorName',
          type: 'string'
        },
        "NCM": {
          name: 'NCM',
          type: 'string'
        },
        "MaterialDescription": {
          name: 'MaterialDescription',
          type: 'string'
        },
        "QtyOrdered": {
          name: 'QtyOrdered',
          type: 'number'
        },
        "UnitPrice": {
          name: 'UnitPrice',
          type: 'number'
        },
        "linkDaObra": {
          name: 'linkDaObra',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ViewPOObraMigoAprovado.js